import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import './index.css';

const ProductCard = ({ product, ratings }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "Not Given"; // If no date, return "Not Given"

    let date = new Date(dateStr);
    if (date.toString() === "Invalid Date") return "Not Given"; // Check if the date is invalid

    let day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
    let year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format in dd-mm-yyyy
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(i < rating ? '★' : '☆');
    }
    return stars.join(''); // Joins all the stars together, with filled or empty ones
  };

  console.log(ratings)

  const calculateAverageRating = (ratings) => {

    if (!ratings || ratings.length === 0) return 0;
    const total = ratings.reduce((acc, rating) => acc + rating.rating, 0);
    return (total / ratings.length) // Return average rating with 1 decimal place
  };


  const averageRating = calculateAverageRating(ratings);
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded(!expanded);

  const isExpired = (validity) => {
    if (!validity) return false;
    const today = new Date();
    const validDate = new Date(validity);
    return validDate < today;
  };

  // return (
  //   <div className="product-card">
  //     <div className="product-image">
  //       <img src={product.productPhoto} alt={product.productName} />
  //     </div>
  //     <div className="product-info">
  //       <h3>{product.productName}</h3>
  //     </div>

  //     <div className="product-details">
  //       <h5 className="border-line">{product.productName}</h5>
  //       {/* <p>{product.productDesc || 'No description available'}</p> */}
  //       <>
  //         {!expanded ? (
  //           <p style={{ color: "yellow", textTransform: "uppercase" }}>
  //             {product.productDesc.length > 100
  //               ? `${product.productDesc.substring(0, 100)}... `
  //               : product.productDesc}
  //             {product.productDesc.length > 100 && (
  //               <span
  //                 style={{ color: "skyblue", cursor: "pointer" }}
  //                 onClick={toggleExpanded}
  //               >
  //                 more
  //               </span>
  //             )}
  //           </p>
  //         ) : (
  //           <div
  //             style={{
  //               maxHeight: "150px",
  //               overflowY: "auto",
  //               border: "1px solid #999",
  //               padding: "8px",
  //               borderRadius: "4px",
  //               background: "#222",
  //               color: "yellow",
  //               textTransform: "uppercase",
  //             }}
  //           >
  //             {product.productDesc}
  //             <div>
  //               <span
  //                 style={{ color: "skyblue", cursor: "pointer" }}
  //                 onClick={toggleExpanded}
  //               >
  //                 ...less
  //               </span>
  //             </div>
  //           </div>
  //         )}
  //       </>
  //       <p><strong>Price:</strong> {product.productPrice}</p>
  //       {/* <p><strong>Offer:</strong> {product.offer ? `${product.offer}%` : 'No offer available'}</p> */}
  //       <p
  //         style={{
  //           color: isExpired(product.validity) ? 'red' : 'yellow',
  //           textDecoration: isExpired(product.validity) ? 'line-through' : 'none',
  //           textTransform: 'uppercase',
  //         }}
  //       >
  //         <strong>Offer:</strong> {product.offer ? `${product.offer}%` : 'No offer available'}{' '}
  //         {isExpired(product.validity) && '(Expired!)'}
  //       </p>

  //       {/* <p><strong>Validity:</strong> {formatDate(product.validity) || 'N/A'}</p> */}
  //       <p
  //         style={{
  //           color: isExpired(product.validity) ? 'red' : 'yellow',
  //           textDecoration: isExpired(product.validity) ? 'line-through' : 'none',
  //           textTransform: 'uppercase',
  //         }}
  //       >
  //         Validity: {formatDate(product.validity)} {isExpired(product.validity) && '(Expired!)'}
  //       </p>

  //       <p><strong>Average Rating:</strong> {renderStars(Math.round(averageRating))} ({averageRating.toFixed(1)})</p>

  //       <button className="more-info-btn" onClick={handleOpenModal}>More About</button>
  //     </div>

  //     <Modal isOpen={isModalOpen} onClose={handleCloseModal} product={product} />
  //   </div>
  // );


return (
  <>
    <div
      style={{
        background: "#fff",
        borderRadius: "22px",
        overflow: "hidden",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        transition: "0.3s",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        
      }}
    >
      {/* IMAGE */}
      <div
        style={{
          width: "100%",
          height: "240px",
          overflow: "hidden",
        }}
      >
        <img
          src={product.productPhoto}
          alt={product.productName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </div>

      {/* CONTENT */}
      <div
        style={{
          padding: "22px",
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        {/* TITLE */}
        <h3
          style={{
            fontSize: "20px",
            fontWeight: "700",
            color: "#1e293b",
            marginBottom: "12px",
            lineHeight: "32px",
          }}
        >
          {product.productName}
        </h3>

        {/* DESCRIPTION */}
        {!expanded ? (
          <p
            style={{
              color: "#64748b",
              fontSize: "13px",
              lineHeight: "28px",
              marginBottom: "18px",
            }}
          >
            {product.productDesc.length > 120
              ? `${product.productDesc.substring(0, 120)}... `
              : product.productDesc}

            {product.productDesc.length > 120 && (
              <span
                onClick={toggleExpanded}
                style={{
                  color: "#1e3a8a",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                more
              </span>
            )}
          </p>
        ) : (
          <div
            style={{
              maxHeight: "130px",
              overflowY: "auto",
              color: "#64748b",
              fontSize: "13px",
              lineHeight: "28px",
              marginBottom: "18px",
            }}
          >
            {product.productDesc}

            <div>
              <span
                onClick={toggleExpanded}
                style={{
                  color: "#1e3a8a",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                less
              </span>
            </div>
          </div>
        )}

        {/* DETAILS */}
        <div
          style={{
            borderTop: "1px solid #e2e8f0",
            paddingTop: "18px",
            marginTop: "auto",
          }}
        >
          {/* PRICE */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <span
              style={{
                color: "#64748b",
                fontSize: "13px",
              }}
            >
              Price
            </span>

            <span
              style={{
                color: "#1e3a8a",
                fontWeight: "700",
                fontSize: "15px",
              }}
            >
              ₹{product.productPrice}
            </span>
          </div>

          {/* OFFER */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <span
              style={{
                color: "#64748b",
                fontSize: "13px",
              }}
            >
              Offer
            </span>

            <span
              style={{
                color: isExpired(product.validity)
                  ? "red"
                  : "#16a34a",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              {product.offer
                ? `${product.offer}%`
                : "No Offer"}
            </span>
          </div>

          {/* VALIDITY */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <span
              style={{
                color: "#64748b",
                fontSize: "13px",
              }}
            >
              Validity
            </span>

            <span
              style={{
                color: isExpired(product.validity)
                  ? "red"
                  : "#0f172a",
                fontWeight: "600",
                fontSize: "13px",
              }}
            >
              {formatDate(product.validity)}
            </span>
          </div>

          {/* RATING */}
          <div
            style={{
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                color: "#f59e0b",
                fontSize: "15px",
                marginBottom: "5px",
              }}
            >
              {renderStars(Math.round(averageRating))}
            </div>

            <span
              style={{
                color: "#64748b",
                fontSize: "14px",
              }}
            >
              ({averageRating.toFixed(1)})
            </span>
          </div>

          {/* BUTTON */}
          <button
            onClick={handleOpenModal}
            style={{
              width: "100%",
              height: "52px",
              border: "none",
              borderRadius: "14px",
              background:
                "linear-gradient(135deg,#1e3a8a,#2563eb)",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s",
            }}
          >
            More About
          </button>
        </div>
      </div>
    </div>

    <Modal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      product={product}
    />
  </>
);
};

export default ProductCard;
